import { useI18n } from 'vue-i18n'
import type { SubscribeConfigItem, FuelBagConfigItem, ProBusinessRightsConfigItem, proConfigItem}  from '@/types/pro'
import type { EnterprisePricingMode } from '~/config/enterpriseLanding'
import useUserStore from '~/store/modules/user'
import useProStore from '~/store/modules/pro'
// 获取当前企业套餐
export function getProBusinessSubscribeConfig(lang?: string, pricingMode: EnterprisePricingMode = 'local') :SubscribeConfigItem[]{
    const { $i18n } = useNuxtApp()
    const t = $i18n.t
    let configList: SubscribeConfigItem[] = [];
    const proConfigStore = useProStore()
    const isGlobal = pricingMode === 'global'
    const priceLevels = isGlobal
      ? ['base', 'professional', 'advanced']
      : ['base', 'mid', 'high']
    let proConfigList = isGlobal ? proConfigStore.globalProConfig : proConfigStore.proConfig
    if (lang) {
      proConfigList = proConfigList
        .filter(item => item.currency === lang && item.interval === '1year' && priceLevels.includes(item.level))
        .sort((left, right) => priceLevels.indexOf(left.level) - priceLevels.indexOf(right.level))
    }
    const roleRightsMap = useUserStore().roleRightsMap
    const roleRightsList = isGlobal
      ? [roleRightsMap?.global_base, roleRightsMap?.global_middle, roleRightsMap?.global_high]
      : [roleRightsMap?.base, roleRightsMap?.middle, roleRightsMap?.high]
    console.log('proConfigList', proConfigList, roleRightsMap)
    for(let i = 0; i < proConfigList.length; i++){
      let rights = roleRightsList[i]
      let proConfig = proConfigList[i]
      let tips = []
      let fileTypes = rights?.fileTypes ? rights?.fileTypes.split(",") : ["PDF", "Word"]
      let fileTypesStr = "PDF、Word"
      if(fileTypes.length > 3){
        let arr = fileTypes.splice(0, 3)
        let str = arr.join("、")
        fileTypesStr = t(`pro_business_subscribe_item_tip2_2`).replace("PDF、Word、Excel", str)
      }else {
        let str = fileTypes.join("、")
        fileTypesStr = t(`pro_business_subscribe_item_tip2_1`).replace("PDF、Word", str)
      }
      if (i == 0) {
        tips.push({
          title: t(`pro_business_subscribe_item_tip1`).replace("*", rights?.memberCountLimit || 10),
        },
        {
          title: fileTypesStr,
        },
        {
          title: t(`pro_business_subscribe_item_tip3`).replace("*", rights?.batchTransMaxLimit || 10),
        },
        {
          title: t(`pro_business_subscribe_item_tip4_1`),
        },
        {
          title: t(`pro_business_subscribe_item_tip5_1`),
        })
      }else{
        tips.push({
          title: t("pro_business_subscribe_item_tip1").replace("*", rights?.memberCountLimit || 10),
        },
        {
          title: fileTypesStr,
        },
        {
          title: t("pro_business_subscribe_item_tip3").replace("*", rights?.batchTransMaxLimit || 10),
        },
        {
          title: t("pro_business_subscribe_item_tip4_2"),
        },
        {
          title: t("pro_business_subscribe_item_tip5_2"),
        },)
      }
      configList.push({
          title: t(`pro_business_subscribe_item_title${i + 1}`),
          subTitle: t(`pro_business_subscribe_item_subtitle${i + 1}`),
          realPrice: proConfig.realPrice,
          bizAgentRealPrice: proConfig.bizAgentRealPrice,
          originalPrice: proConfig.originPrice,
          charNum: rights?.charsMaxLimit,
          pageNum: rights?.pdfPages,
          type: i,
          tips: tips,
          choiceId: proConfig.choiceId
      })
    }
    configList.push({
      title: t("pro_business_subscribe_item_title4"),
      subTitle: t("pro_business_subscribe_item_subtitle4"),
      type: 3,
      isCustomized: true,
      tips: [
        {
          title: t("pro_business_subscribe_item_customized_1"),
        },
        {
          title: t("pro_business_subscribe_item_customized_2"),
        },
        {
          title: t("pro_business_subscribe_item_customized_3"),
        },
        {
          title: t("pro_business_subscribe_item_customized_4"),
        },
        {
          title: t("pro_business_subscribe_item_customized_5"),
        },
      ],
    })
    return configList
}

// 获取当前企业加油包套餐
export function getProBusinessFuelBagConfig(
  lang?: string,
  pricingMode: EnterprisePricingMode = 'local',
) :FuelBagConfigItem[]{
    let configList: FuelBagConfigItem[] = [];
    const proConfigStore = useProStore()
    const isGlobal = pricingMode === 'global'
    let fuelConfigList = isGlobal
      ? proConfigStore.globalProFuelBagConfig
      : proConfigStore.proFuelBagConfig
    if (lang) {
      const choicePattern = isGlobal
        ? /^biz-global-add-oil-0[1-6]-[a-z]{3}$/i
        : /^biz-add-oil-0[1-6]-[a-z]{3}$/i
      fuelConfigList = fuelConfigList.filter((item) => {
        return choicePattern.test(item.choiceId)
          && item.choiceId.endsWith(`-${lang}`)
      }).sort((a, b) => {
        const getOrder = (choiceId: string) => Number(choiceId.match(/-oil-(\d+)-/i)?.[1] || 0)
        return getOrder(a.choiceId) - getOrder(b.choiceId)
      })
    }
    for(let i = 0; i < fuelConfigList.length; i++){
      let fuelConfig = fuelConfigList[i]
      configList.push({
        realPrice: fuelConfig.realPrice,
        bizAgentRealPrice: fuelConfig.bizAgentRealPrice,
        charNum: fuelConfig.addCharCount,
        discount: fuelConfig.cutDownRate,
        originalPrice: fuelConfig.originPrice,
        choiceId: fuelConfig.choiceId,
        type: i,
      })
    }
    return configList
}

// 获取企业权益对比数据 type == 1 (智能翻译) type == 2 (协作管理) type == 3 (加密安全) type == 4 (服务)
export function getProBusinessRightsConfig(type: number) :ProBusinessRightsConfigItem[]{
    const { $i18n } = useNuxtApp()
    const t = $i18n.t
    let configList: ProBusinessRightsConfigItem[] = [];
    const userStore = useUserStore()
    const roleRightsMap = userStore.roleRightsMap
    console.log("roleRightsMap===", roleRightsMap, type)
    if(type == 1){
        for(let i = 0; i < 9; i++){
            let title = t(`pro_business_rights_translate_${i + 1}`)
            if (i == 5) {
              continue;
            }
            configList.push({
                title: title,
                valueBase: i == 0 ? roleRightsMap?.base?.transLangLimitStr : true,
                valueMid: i == 0 ? roleRightsMap?.middle?.transLangLimitStr : true,
                valueHigh: i == 0 ? roleRightsMap?.high?.transLangLimitStr : true,
                type: i == 0 ? 1 : 2
            })
        }
    }else if(type == 2){
        let data = {
            freeTime: {
                base: roleRightsMap?.base?.historySaveDayLimit || 365,
                mid: roleRightsMap?.middle?.historySaveDayLimit || 365,
                high: roleRightsMap?.high?.historySaveDayLimit || 365
            },
            batchUpload: {
                base: roleRightsMap?.base?.batchUploadLimit || 5 + t('pro_business_rights_individual'),
                mid: roleRightsMap?.middle?.batchUploadLimit || 10 + t('pro_business_rights_individual'),
                high: roleRightsMap?.high?.batchUploadLimit || 20 + t('pro_business_rights_individual')
            },
            batchTranslate: {
                base: roleRightsMap?.base?.batchTransMaxLimit || 5 + t('pro_business_rights_individual'),
                mid: roleRightsMap?.middle?.batchTransMaxLimit || 10 + t('pro_business_rights_individual'),
                high: roleRightsMap?.high?.batchTransMaxLimit || 20 + t('pro_business_rights_individual')
            },
            teamMember: {
                base: roleRightsMap?.base?.memberCountLimit || 10 + t('pro_business_rights_individual'),
                mid: roleRightsMap?.middle?.memberCountLimit || 20 + t('pro_business_rights_individual'),
                high: roleRightsMap?.high?.memberCountLimit || 30 + t('pro_business_rights_individual')
            },
            translateChannel: {
                base: t('normal_engine') + '+' + t('chat_mode_senior_title'),
                mid: t('normal_engine') + '+' + t('chat_mode_senior_title'),
                high: t('normal_engine') + '+' + t('chat_mode_senior_title')
            }
        }
        for(let i = 0; i < 10; i++){
            let title = t(`pro_business_rights_collaborate_${i + 1}`)
            let baseTitle: string = ""
            let midTitle: string = ""
            let highTitle: string= ""
            if (i == 5) {
                baseTitle = data.freeTime.base
                midTitle = data.freeTime.mid
                highTitle = data.freeTime.high
            }else if (i == 6) {
                baseTitle = data.batchUpload.base
                midTitle = data.batchUpload.mid
                highTitle = data.batchUpload.high
            }else if (i == 7) {
                baseTitle = data.batchTranslate.base
                midTitle = data.batchTranslate.mid
                highTitle = data.batchTranslate.high
            }else if (i == 8) {
                baseTitle = data.teamMember.base
                midTitle = data.teamMember.mid
                highTitle = data.teamMember.high
            }else if (i == 9) {
                baseTitle = data.translateChannel.base
                midTitle = data.translateChannel.mid
                highTitle = data.translateChannel.high
            }
            configList.push({
                title: title,
                valueBase: i >= 5 ? baseTitle : true,
                valueMid: i >= 5 ? midTitle : true,
                valueHigh: i >= 5 ? highTitle : true,
                type: i >= 5 ? 1 : 2
            })
        }
    }else if(type == 3){
        configList.push({
            title: t("pro_business_rights_encryption_1"),
            valueBase: true,
            valueMid: true,
            valueHigh: true,
            type: 2
        })
        configList.push({
          title: t("pro_business_rights_encryption_2"),
          valueBase: false,
          valueMid: true,
          valueHigh: true,
          type: 2
      })
    }else if(type == 4){
        for(let i = 0; i < 4; i++){
            let title = t(`pro_business_rights_service_${i + 1}`)
            configList.push({
                title: title,
                valueBase: i == 0 ? false : true,
                valueMid: i == 0 ? false : true,
                valueHigh: true,
                type: 2
            })
        }
    }
    return configList
}

export function getLoginConfig() :proConfigItem[]{
  const { $i18n } = useNuxtApp()
  const t = $i18n.t
  let configList: proConfigItem[] = [];
  configList = [
      {   title: t("login_rights_title_1"), textType: 2, content: "" },
      {   title: t("login_rights_title_2"), textType: 2, content: ""},
      {   title: t("login_rights_title_3"), textType: 2, content: ""},
      {   title: t("login_rights_title_4"), textType: 2, content: ""},
      {   title: t("login_rights_title_5"),textType: 2, content: ""},
      {   title: t("login_rights_title_6"),textType: 2, content: ""},
  ]
  
  return configList
}
